import * as React from "react";
const SvgDaylightStudio = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M18.776 10.75a.75.75 0 0 0-1.5 0v1a.75.75 0 0 0 1.5 0v-1ZM11.514 6.013a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75ZM13.427 9.544a.75.75 0 1 0 1.06 1.061l.707-.707a.75.75 0 1 0-1.06-1.06l-.707.706Z"
      fill="currentColor"
    />
    <path
      d="M5.751 3a2.75 2.75 0 0 0-2.75 2.75v12.5A2.75 2.75 0 0 0 5.751 21h12.5a2.75 2.75 0 0 0 2.75-2.75V5.75A2.75 2.75 0 0 0 18.251 3h-12.5Zm9.25 3.005a3 3 0 0 0 4.5 2.599v9.646c0 .69-.56 1.25-1.25 1.25h-12.5c-.11 0-.216-.014-.317-.04l1.987-.98a.748.748 0 0 0 .305-.15l2.298-1.132a1.75 1.75 0 0 0 .977-1.57V7.461a1.75 1.75 0 0 0-1.175-1.653L6.065 4.5h9.34a2.985 2.985 0 0 0-.404 1.505Zm3 1.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM4.517 5.55l1.984.69v5.01h-2v-5.5c0-.068.005-.135.016-.2Zm1.984 7.2v4.512l-2 .985V12.75h2Zm1.5 0h1.5v2.878a.25.25 0 0 1-.14.224l-1.36.67V12.75Zm1.5-1.5H8V6.762l1.332.463c.1.035.168.13.168.236v3.789Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgDaylightStudio;
